import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import API from "./config/API";

const PgOwnerRegistration = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const locationReferralCode =
    location.state?.referralCode ||
    new URLSearchParams(location.search).get("referralCode") ||
    "";
  const [formData, setFormData] = useState({
    pgOwnerName: "",
    pgOwnerContactNo: "",
    pgOwnerEmailId: "",
    pgName: "",
    state: "",
    district: "",
    city: "",
    pgAddress: "",
    pgGoogleMapUrl: "",
    pgLocation: "",
    pgType: "",
    subscriptionType: "Basic",

    pgAccountCreatedBy: locationReferralCode ? "Referral_By" : "Self",

    referralCode: locationReferralCode,

    requestedFloorCount: "",
    pgVerifiedByAdminStatus: "pending",
  });
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [messageType, setMessageType] = useState("");

  const user = JSON.parse(localStorage.getItem("user"));

  useEffect(() => {
    if (locationReferralCode) {
      setFormData((prev) => ({
        ...prev,
        pgAccountCreatedBy: "Referral_By",
        referralCode: locationReferralCode,
      }));
    }
  }, [locationReferralCode]);

  const handleChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    if (message) {
      setMessage("");
      setMessageType("");
    }
  };

  const handleAccountCreatedByChange = (e) => {
    const value = e.target.value;

    setFormData((prev) => ({
      ...prev,
      pgAccountCreatedBy: value,
      referralCode: value === "Referral_By" ? prev.referralCode : "",
    }));
  };

  const selectSubscription = (subscriptionType) => {
    setFormData((prev) => ({
      ...prev,
      subscriptionType,
    }));

    if (message) {
      setMessage("");
      setMessageType("");
    }
  };

  const isValidEmail = (email) => {
    return /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(
      email.trim(),
    );
  };

  const isValidContact = (contact) => {
    return /^[6-9]\d{9}$/.test(contact);
  };

  const isValidGoogleMapUrl = (url) => {
    if (!url || url.trim() === "") {
      return true;
    }

    return /^https?:\/\/(www\.)?(google\.[a-z.]+\/maps|maps\.google\.[a-z.]+|goo\.gl\/maps)/i.test(
      url.trim(),
    );
  };

  const validateForm = () => {
    if (!formData.pgOwnerName.trim()) {
      setMessage("Please enter PG Owner Name.");
      setMessageType("error");
      return false;
    }

    if (!formData.pgOwnerContactNo) {
      setMessage("Please enter Contact Number.");
      setMessageType("error");
      return false;
    }

    if (!isValidContact(formData.pgOwnerContactNo)) {
      setMessage("Please enter a valid 10-digit Indian mobile number.");
      setMessageType("error");
      return false;
    }

    if (!formData.pgOwnerEmailId.trim()) {
      setMessage("Please enter Email Address.");
      setMessageType("error");
      return false;
    }

    if (!isValidEmail(formData.pgOwnerEmailId)) {
      setMessage("Please enter a valid Email Address.");
      setMessageType("error");
      return false;
    }

    if (!formData.pgName.trim()) {
      setMessage("Please enter PG Name.");
      setMessageType("error");
      return false;
    }

    if (!formData.state.trim()) {
      setMessage("Please enter State.");
      setMessageType("error");
      return false;
    }

    if (!formData.district.trim()) {
      setMessage("Please enter District.");
      setMessageType("error");
      return false;
    }

    if (!formData.city.trim()) {
      setMessage("Please enter City.");
      setMessageType("error");
      return false;
    }

    if (!formData.pgLocation.trim()) {
      setMessage("Please enter PG Location / Area.");
      setMessageType("error");
      return false;
    }

    if (!formData.pgType) {
      setMessage("Please select PG Type.");
      setMessageType("error");
      return false;
    }

    if (!formData.subscriptionType) {
      setMessage("Please select Subscription Type.");
      setMessageType("error");
      return false;
    }

    if (
      formData.pgAccountCreatedBy === "Referral_By" &&
      !formData.referralCode.trim()
    ) {
      setMessage("Please enter Referral Code.");
      setMessageType("error");
      return false;
    }

    if (!isValidGoogleMapUrl(formData.pgGoogleMapUrl)) {
      setMessage("Please enter a valid Google Maps URL.");
      setMessageType("error");
      return false;
    }

    if (!formData.requestedFloorCount) {
      setMessage("Please enter how many floors your PG has.");
      setMessageType("error");
      return false;
    }

    const floorCount = Number(formData.requestedFloorCount);

    if (!Number.isInteger(floorCount) || floorCount < 1) {
      setMessage("Please enter a valid floor count. Minimum is 1.");
      setMessageType("error");
      return false;
    }

    if (floorCount > 100) {
      setMessage("Floor count cannot be more than 100.");
      setMessageType("error");
      return false;
    }

    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!validateForm()) {
      return;
    }

    setLoading(true);
    setMessage("");
    setMessageType("");

    try {
      const payload = {
        pgOwnerName: formData.pgOwnerName.trim(),
        pgOwnerContactNo: Number(formData.pgOwnerContactNo),
        pgOwnerEmailId: formData.pgOwnerEmailId.trim(),
        pgName: formData.pgName.trim(),
        state: formData.state.trim(),
        district: formData.district.trim(),
        city: formData.city.trim(),
        pgAddress: formData.pgAddress.trim(),
        requestedFloorCount: Number(formData.requestedFloorCount),
        pgGoogleMapUrl: formData.pgGoogleMapUrl.trim(),
        pgLocation: formData.pgLocation.trim(),
        pgType: formData.pgType,
        subscriptionType: formData.subscriptionType,
        pgAccountCreatedBy: formData.pgAccountCreatedBy,
        referralCode:
          formData.pgAccountCreatedBy === "Referral_By"
            ? formData.referralCode.trim()
            : null,
        pgVerifiedByAdminStatus:
          "Approval Pending. Please wait for Admin Approval.",
      };

      console.log("PG Owner Registration Payload:", payload);

      const response = await fetch(
        `${API.V2}/pgOwner/createPgOwnerRegistration`,
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",

            ...(user?.jwtToken
              ? {
                  Authorization: `Bearer ${user.jwtToken}`,
                }
              : {}),
          },

          body: JSON.stringify(payload),
        },
      );

      const data = await response.json();

      console.log("Registration Response:", data);

      if (response.ok && data?.statusCode === 200) {
        setMessage(
          data?.message ||
            "Registration successful. OTP sent to your email/mobile.",
        );

        setMessageType("success");

        setTimeout(() => {
          navigate("/pgOwnerRegistrationOtp", {
            state: {
              pgOwnerEmailId: formData.pgOwnerEmailId.trim(),
              mobileNumber: Number(formData.pgOwnerContactNo),
            },
          });
        }, 1000);
      } else {
        setMessage(
          data?.message ||
            "Registration failed. Please check the details and try again.",
        );

        setMessageType("error");
      }
    } catch (error) {
      console.error("Registration Error:", error);

      setMessage("Unable to connect to server. Please try again later.");
      setMessageType("error");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="pg-owner-registration-page">
      {/* =========================================
          INLINE CSS
      ========================================= */}
      <style>
        {`
          * {
            box-sizing: border-box;
          }

          .pg-owner-registration-page {
            min-height: 100vh;
            width: 100%;
            padding: 35px 20px;
            background:
              linear-gradient(
                135deg,
                #eef2ff 0%,
                #f8fafc 45%,
                #eef2ff 100%
              );
            font-family:
              Arial,
              Helvetica,
              sans-serif;
          }

          .pg-owner-registration-card {
            width: 100%;
            max-width: 1250px;
            margin: 0 auto;
            background: #ffffff;
            border-radius: 22px;
            padding: 35px;
            box-shadow:
              0 15px 45px rgba(15, 23, 42, 0.12);
            border: 1px solid #e2e8f0;
          }

          /* =========================================
             HEADER
          ========================================= */

          .registration-header {
            text-align: center;
            margin-bottom: 35px;
          }

          .registration-header h1 {
            margin: 0;
            font-size: 32px;
            font-weight: 800;
            color: #1e293b;
          }

          .registration-header p {
            margin: 10px 0 0;
            font-size: 15px;
            color: #64748b;
          }

          /* =========================================
             SECTION TITLE
          ========================================= */

          .section-title {
            display: flex;
            align-items: center;
            gap: 10px;
            margin-top: 28px;
            margin-bottom: 18px;
            padding-bottom: 10px;
            border-bottom: 2px solid #e2e8f0;

            font-size: 18px;
            font-weight: 800;
            color: #334155;
          }

          .section-title span {
            font-size: 22px;
          }

          /* =========================================
             FORM GRID
          ========================================= */

          .form-grid {
            display: grid;
            grid-template-columns:
              repeat(2, minmax(0, 1fr));
            gap: 20px;
          }

          .form-group {
            display: flex;
            flex-direction: column;
            min-width: 0;
          }

          .form-group.full-width {
            grid-column: 1 / -1;
          }

          .form-group label {
            margin-bottom: 7px;
            color: #334155;
            font-size: 14px;
            font-weight: 700;
          }

          .form-group label span {
            color: #dc2626;
          }

          .form-group input,
          .form-group select {
            width: 100%;
            min-height: 46px;
            padding: 11px 13px;
            border: 1px solid #cbd5e1;
            border-radius: 9px;
            background: #ffffff;
            color: #1e293b;
            font-size: 14px;
            outline: none;
            transition: 0.2s ease;
          }

          .form-group input:focus,
          .form-group select:focus {
            border-color: #4f46e5;
            box-shadow:
              0 0 0 3px rgba(79, 70, 229, 0.10);
          }

          .form-group input::placeholder {
            color: #94a3b8;
          }

          .form-group small {
            margin-top: 6px;
            color: #64748b;
            font-size: 12px;
          }

          .readonly-input {
            background: #f8fafc !important;
            color: #64748b !important;
            cursor: not-allowed;
            font-weight: 600;
          }

          /* =========================================
             SUBSCRIPTION PLANS
          ========================================= */

          .subscription-plans {
            display: grid;
            grid-template-columns:
              repeat(4, minmax(0, 1fr));
            gap: 12px;
            width: 100%;
          }

          .subscription-card {
            position: relative;
            min-height: 175px;
            padding: 18px 10px;

            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: center;

            text-align: center;

            background: #ffffff;
            border: 2px solid #e2e8f0;
            border-radius: 16px;

            cursor: pointer;

            transition:
              transform 0.25s ease,
              box-shadow 0.25s ease,
              border-color 0.25s ease,
              background 0.25s ease;
          }

          .subscription-card:hover {
            transform: translateY(-4px);
          }

          .subscription-card.selected {
            transform: translateY(-3px);
          }

          /* =========================================
             BASIC
          ========================================= */

          .basic-plan {
            border-color: #64748b;
          }

          .basic-plan:hover,
          .basic-plan.selected {
            background: #f1f5f9;
            border-color: #475569;
            box-shadow:
              0 10px 25px
              rgba(71, 85, 105, 0.25);
          }

          /* =========================================
             SILVER
          ========================================= */

          .silver-plan {
            border-color: #94a3b8;
          }

          .silver-plan:hover,
          .silver-plan.selected {
            background:
              linear-gradient(
                135deg,
                #f8fafc,
                #e2e8f0
              );

            border-color: #64748b;

            box-shadow:
              0 10px 25px
              rgba(100, 116, 139, 0.30);
          }

          /* =========================================
             GOLD
          ========================================= */

          .gold-plan {
            border-color: #eab308;
          }

          .gold-plan:hover,
          .gold-plan.selected {
            background:
              linear-gradient(
                135deg,
                #fffbeb,
                #fef3c7
              );

            border-color: #d97706;

            box-shadow:
              0 10px 25px
              rgba(217, 119, 6, 0.30);
          }

          /* =========================================
             PREMIUM
          ========================================= */

          .premium-plan {
            border-color: #8b5cf6;
          }

          .premium-plan:hover,
          .premium-plan.selected {
            background:
              linear-gradient(
                135deg,
                #faf5ff,
                #ede9fe
              );

            border-color: #7c3aed;

            box-shadow:
              0 10px 25px
              rgba(124, 58, 237, 0.30);
          }

          /* =========================================
             PLAN CONTENT
          ========================================= */

          .plan-icon {
            font-size: 28px;
            line-height: 1;
            margin-bottom: 7px;
          }

          .plan-name {
            font-size: 19px;
            font-weight: 800;
            margin-bottom: 5px;
          }

          .basic-plan .plan-name {
            color: #475569;
          }

          .silver-plan .plan-name {
            color: #475569;
          }

          .gold-plan .plan-name {
            color: #b45309;
          }

          .premium-plan .plan-name {
            color: #7c3aed;
          }

          .plan-duration {
            color: #64748b;
            font-size: 12px;
            font-weight: 700;
            margin-bottom: 8px;
          }

          .plan-price {
            font-size: 23px;
            font-weight: 900;
            margin-bottom: 5px;
          }

          .basic-plan .plan-price {
            color: #334155;
          }

          .silver-plan .plan-price {
            color: #475569;
          }

          .gold-plan .plan-price {
            color: #b45309;
          }

          .premium-plan .plan-price {
            color: #7c3aed;
          }

          .plan-label {
            font-size: 10px;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 0.6px;
            color: #64748b;
          }

          /* =========================================
             SELECTED BADGE
          ========================================= */

          .subscription-card.selected::after {
            content: "✓ Selected";

            position: absolute;
            top: 7px;
            right: 7px;

            padding: 4px 7px;

            border-radius: 20px;

            font-size: 9px;
            font-weight: 800;

            color: #ffffff;
          }

          .basic-plan.selected::after {
            background: #475569;
          }

          .silver-plan.selected::after {
            background: #64748b;
          }

          .gold-plan.selected::after {
            background: #d97706;
          }

          .premium-plan.selected::after {
            background: #7c3aed;
          }

          /* =========================================
             MESSAGE
          ========================================= */

          .registration-message {
            margin-top: 25px;
            padding: 13px 16px;
            border-radius: 9px;
            font-size: 14px;
            font-weight: 600;
            text-align: center;
          }

          .success-message {
            color: #166534;
            background: #dcfce7;
            border: 1px solid #86efac;
          }

          .error-message {
            color: #991b1b;
            background: #fee2e2;
            border: 1px solid #fca5a5;
          }

          /* =========================================
             BUTTON
          ========================================= */

          .button-container {
            display: flex;
            justify-content: center;
            margin-top: 30px;
          }

          .register-button {
            min-width: 220px;
            padding: 13px 28px;

            border: none;
            border-radius: 10px;

            background:
              linear-gradient(
                135deg,
                #4f46e5,
                #7c3aed
              );

            color: #ffffff;

            font-size: 15px;
            font-weight: 800;

            cursor: pointer;

            box-shadow:
              0 8px 20px
              rgba(79, 70, 229, 0.25);

            transition: all 0.25s ease;
          }

          .register-button:hover:not(:disabled) {
            transform: translateY(-2px);

            box-shadow:
              0 12px 25px
              rgba(79, 70, 229, 0.35);
          }

          .register-button:disabled {
            opacity: 0.65;
            cursor: not-allowed;
          }

          /* =========================================
             TABLET
          ========================================= */

          @media (max-width: 1000px) {

            .subscription-plans {
              grid-template-columns:
                repeat(2, minmax(0, 1fr));
            }

          }

          /* =========================================
             MOBILE
          ========================================= */

          @media (max-width: 700px) {

            .pg-owner-registration-page {
              padding: 15px 10px;
            }

            .pg-owner-registration-card {
              padding: 22px 16px;
              border-radius: 16px;
            }

            .registration-header h1 {
              font-size: 25px;
            }

            .form-grid {
              grid-template-columns: 1fr;
              gap: 16px;
            }

            .form-group.full-width {
              grid-column: auto;
            }

            .subscription-plans {
              grid-template-columns: 1fr 1fr;
              gap: 10px;
            }

            .subscription-card {
              min-height: 155px;
            }

            .plan-icon {
              font-size: 24px;
            }

            .plan-name {
              font-size: 17px;
            }

            .plan-price {
              font-size: 20px;
            }

            .subscription-card.selected::after {
              font-size: 8px;
              padding: 3px 5px;
            }

            .register-button {
              width: 100%;
            }
          }

          /* =========================================
             SMALL MOBILE
          ========================================= */

          @media (max-width: 420px) {

            .subscription-plans {
              grid-template-columns: 1fr;
            }

            .subscription-card {
              min-height: 145px;
            }

          }
        `}
      </style>

      <div className="pg-owner-registration-card">
        {/* HEADER */}
        <div className="registration-header">
          <h1>PG Owner Registration</h1>
          <p>Register your PG and start managing your property</p>
        </div>

        <form onSubmit={handleSubmit}>
          {/* =========================================
              OWNER DETAILS
          ========================================= */}

          <div className="section-title">
            <span>👤</span>
            Owner Details
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label>
                PG Owner Name <span>*</span>
              </label>

              <input
                type="text"
                name="pgOwnerName"
                value={formData.pgOwnerName}
                onChange={handleChange}
                placeholder="Enter owner Full Name"
                maxLength={100}
              />
            </div>

            <div className="form-group">
              <label>
                Contact Number <span>*</span>
              </label>

              <input
                type="tel"
                name="pgOwnerContactNo"
                value={formData.pgOwnerContactNo}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");

                  if (value.length <= 10) {
                    setFormData((prev) => ({
                      ...prev,
                      pgOwnerContactNo: value,
                    }));
                  }
                }}
                placeholder="Enter 10-digit mobile number"
                maxLength={10}
              />
            </div>

            <div className="form-group">
              <label>
                Email Address <span>*</span>
              </label>

              <input
                type="email"
                name="pgOwnerEmailId"
                value={formData.pgOwnerEmailId}
                onChange={handleChange}
                placeholder="Enter Valid Email Address only"
                maxLength={150}
              />
            </div>

            <div className="form-group">
              <label>
                PG Name <span>*</span>
              </label>

              <input
                type="text"
                name="pgName"
                value={formData.pgName}
                onChange={handleChange}
                placeholder="Enter PG name"
                maxLength={150}
              />
            </div>
          </div>

          {/* =========================================
              LOCATION DETAILS
          ========================================= */}

          <div className="section-title">
            <span>📍</span>
            PG Location Details
          </div>

          <div className="form-grid">
            <div className="form-group">
              <label>
                State <span>*</span>
              </label>

              <input
                type="text"
                name="state"
                value={formData.state}
                onChange={handleChange}
                placeholder="Enter state"
                maxLength={100}
              />
            </div>

            <div className="form-group">
              <label>
                District <span>*</span>
              </label>

              <input
                type="text"
                name="district"
                value={formData.district}
                onChange={handleChange}
                placeholder="Enter district"
                maxLength={100}
              />
            </div>

            <div className="form-group">
              <label>
                City <span>*</span>
              </label>

              <input
                type="text"
                name="city"
                value={formData.city}
                onChange={handleChange}
                placeholder="Enter city"
                maxLength={100}
              />
            </div>

            <div className="form-group">
              <label>
                PG Location / Area <span>*</span>
              </label>

              <input
                type="text"
                name="pgLocation"
                value={formData.pgLocation}
                onChange={handleChange}
                placeholder="Example: Kukatpally, Hyderabad"
                maxLength={255}
              />
            </div>

            <div className="form-group full-width">
              <label>PG Google Map URL</label>

              <input
                type="url"
                name="pgGoogleMapUrl"
                value={formData.pgGoogleMapUrl}
                onChange={handleChange}
                placeholder="https://maps.google.com/..."
              />

              <small>Optional — paste the Google Maps location URL.</small>
            </div>
          </div>

          {/* =========================================
              PG CONFIGURATION
          ========================================= */}

          <div className="section-title">
            <span>🏠</span>
            PG Configuration
          </div>

          <div className="form-grid">
            {/* PG TYPE */}

            <div className="form-group">
              <label>
                PG Type <span>*</span>
              </label>

              <select
                name="pgType"
                value={formData.pgType}
                onChange={handleChange}
              >
                <option value="">Select PG Type</option>

                <option value="Mens PG">Mens PG</option>

                <option value="Womens PG">Womens PG</option>

                <option value="Co_Living">Co-Living</option>
              </select>
            </div>

            {/* SUBSCRIPTION */}

            <div className="form-group subscription-group">
              <label>
                Subscription Type <span>*</span>
              </label>

              <div className="subscription-plans">
                {/* BASIC */}

                <div
                  className={`subscription-card basic-plan ${
                    formData.subscriptionType === "Basic" ? "selected" : ""
                  }`}
                  onClick={() => selectSubscription("Basic")}
                >
                  <div className="plan-icon">🆓</div>

                  <div className="plan-name">Basic</div>

                  <div className="plan-duration">Free / 3 Months</div>

                  <div className="plan-price">₹0</div>

                  <div className="plan-label">Free Plan</div>
                </div>

                {/* SILVER */}

                <div
                  className={`subscription-card silver-plan ${
                    formData.subscriptionType === "Silver" ? "selected" : ""
                  }`}
                  onClick={() => selectSubscription("Silver")}
                >
                  <div className="plan-icon">🥈</div>

                  <div className="plan-name">Silver</div>

                  <div className="plan-duration">6 Months</div>

                  <div className="plan-price">₹999</div>

                  <div className="plan-label">Paid Plan</div>
                </div>

                {/* GOLD */}

                <div
                  className={`subscription-card gold-plan ${
                    formData.subscriptionType === "Gold" ? "selected" : ""
                  }`}
                  onClick={() => selectSubscription("Gold")}
                >
                  <div className="plan-icon">🥇</div>

                  <div className="plan-name">Gold</div>

                  <div className="plan-duration">1 Year</div>

                  <div className="plan-price">₹1,799</div>

                  <div className="plan-label">Paid Plan</div>
                </div>

                {/* PREMIUM */}

                <div
                  className={`subscription-card premium-plan ${
                    formData.subscriptionType === "Premium" ? "selected" : ""
                  }`}
                  onClick={() => selectSubscription("Premium")}
                >
                  <div className="plan-icon">💎</div>

                  <div className="plan-name">Premium</div>

                  <div className="plan-duration">2 Years</div>

                  <div className="plan-price">₹2,999</div>

                  <div className="plan-label">Paid Plan</div>
                </div>
              </div>
            </div>

            {/* FLOOR COUNT */}

            <div className="form-group">
              <label>
                How Many Floors does your PG have?
                <span>*</span>
              </label>

              <input
                type="text"
                name="requestedFloorCount"
                value={formData.requestedFloorCount}
                onChange={(e) => {
                  const value = e.target.value.replace(/\D/g, "");

                  if (value.length <= 3) {
                    setFormData((prev) => ({
                      ...prev,
                      requestedFloorCount: value,
                    }));
                  }
                }}
                placeholder="Enter number of floors"
                inputMode="numeric"
                maxLength={3}
              />

              <small>Enter numbers only, for example: 1, 2, 3</small>
            </div>

            {/* ACCOUNT CREATED BY */}

            <div className="form-group">
              <label>Account Created By</label>

              <select
                value={formData.pgAccountCreatedBy}
                onChange={handleAccountCreatedByChange}
              >
                <option value="Self">Self</option>

                <option value="Referral_By">Referral By</option>
              </select>
            </div>

            {/* REFERRAL */}

            {formData.pgAccountCreatedBy === "Referral_By" && (
              <div className="form-group">
                <label>
                  Referral Code <span>*</span>
                </label>

                <input
                  type="text"
                  name="referralCode"
                  value={formData.referralCode}
                  onChange={handleChange}
                  placeholder="Enter referral code"
                  maxLength={50}
                  disabled={!!locationReferralCode}
                />
              </div>
            )}

            {/* STATUS */}

            <div className="form-group">
              <label>Account Status</label>

              <input
                type="text"
                value={formData.pgVerifiedByAdminStatus}
                readOnly
                className="readonly-input"
              />
            </div>
          </div>

          {/* MESSAGE */}

          {message && (
            <div
              className={`registration-message ${
                messageType === "success" ? "success-message" : "error-message"
              }`}
            >
              {message}
            </div>
          )}

          {/* SUBMIT */}

          <div className="button-container">
            <button
              type="submit"
              className="register-button"
              disabled={loading}
            >
              {loading ? "Registering..." : "Register PG"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default PgOwnerRegistration;
